import * as React from "react";
import { Loader } from "@/components/ui/loader";

// Shown for the instant between a successful credential check and the redirect
// into the app, where RootLayout holds the same coral Loader until pf-mainweb
// has answered its wake ping (hooks/use-mainweb-warm.ts). Same spinner, same
// placement, no text: the user sees one continuous "loading" from password OK
// to Drive, not a circle that flips into an arrow.
export const SuccessMessage: React.FC = () => (
  <div className="flex justify-center py-8">
    <Loader className="h-8 w-8 text-coral" />
  </div>
);
